/*************************************************************************
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import { locale2 as locale, logging, providers } from "dc-core";

const logger = logging.getLogger("WhatsNewDarkPageTheme");
class WhatsNewDarkPageTheme extends Component {
  getLabel = () => getMessage("whatsNew.darkPageTheme.label");

  getTitle = () => getMessage("whatsNew.darkPageTheme.title");

  getDescription = () => getMessage("whatsNew.darkPageTheme.description");

  getAnimatedIconAsync = async () => {
    const currentLocale = locale.getLocale();
    const DarkPageThemeAnimation = await import("dc-animations/WhatsNew/CustomReadingTheme");
    return DarkPageThemeAnimation.default.loadAsync({ locale: currentLocale });
  };

  async initializeAction(options) {
    const device = await providers.device();
    const isMobileOrTab = device.isMobileDevice() || device.isMobile() || device.isTablet();

    const intentProvider = await providers.intent();
    const isModernViewerEnabled = await intentProvider.isModernViewerEnabled();

    try {
      if (options && options.showCallback) {
        if (!isMobileOrTab && isModernViewerEnabled) {
          options.showCallback(true);
        } else {
          options.showCallback(false);
        }
      }
    } catch (err) {
      logger.warn(err.message);
    }
  }

  executeAction = () => {};

  id = "whats-new-dark-page-theme";

  render() {
    return null;
  }
}

export default WhatsNewDarkPageTheme;
